import { inject, Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { PublicProfileContextService, PublicUserContextService } from '@rma/public/accounts/user';
import { map, of, switchMap } from 'rxjs';
import { TrackableUserType } from '../domain';
import { GoogleTagManagerService } from '../feat-google-tag-manager/google-tag-manager.service';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class UserTrackerService {
  private readonly googleTagManagerService = inject(GoogleTagManagerService);
  private readonly currentUserService = inject(PublicUserContextService);
  private readonly profile = inject(PublicProfileContextService);

  public watchUser() {
    this.currentUserService.currentUser$
      .pipe(
        switchMap((user) => {
          if (!user) {
            return of({ userType: TrackableUserType.Unauthenticated });
          }

          if (user.userType === 'Consumer') {
            return of({ userType: TrackableUserType.Consumer, userId: user.userId });
          }

          // Agent vs Agency is a profile fact (anything non-individual is an agency), resolved from the profile context.
          return this.profile.isIndividual$.pipe(
            map((isIndividual) => ({ userType: isIndividual ? TrackableUserType.Agent : TrackableUserType.Agency, userId: user.userId })),
          );
        }),
        untilDestroyed(this),
      )
      .subscribe((x) => this.googleTagManagerService.trackUser(x));
  }
}
